<template>
<div>
  <span class="col-sm-12 recaptchaMessage" v-if="this.showAlbanianMessage">
      {{ $t('labels.UseRecaptcha') }}
  </span>
 <div id="recaptcha" class="col-sm-12">
  <span class="col-sm-12 linkColor" v-if="errorinrecaptcha == true">
      {{ $t('validations.recaptchaerror') }}
  </span>
  <vue-recaptcha ref="recaptcha" v-bind:sitekey="keyfromconfig"  @verify="onVerify" @expired="onExpired">
  </vue-recaptcha>
</div>
</div>
</template>

<script>
import Vue from 'vue';
import VueRecaptcha from 'vue-recaptcha';
import OnboardInputMixin from '@/mixins/OnboardInputMixin';
import config from '../../config';

export default {
  components: { VueRecaptcha },
  mixins: [OnboardInputMixin],
  mounted() {
    const mytime = Date.now();
    Vue.loadScript(`https://www.google.com/recaptcha/api.js?${mytime}`)
      .then(() => {
        this.errorinrecaptcha = false;
        this.$v.value.$model = '';
        this.containsError(this.$v.value);

        const recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute('src', `https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=${this.currentLanguage}`);
        recaptchaScript.setAttribute('id', 'recaptchascriptid');
        document.head.appendChild(recaptchaScript);
      })
      .catch(() => {
        this.errorinrecaptcha = true;
      });
  },
  computed: {
    currentLanguage() {
      return this.$store.state.currentLanguage;
    },
    showAlbanianMessage() {
      return this.currentLanguage === 'sq';
    },
  },
  data() {
    return {
      keyfromconfig: config.recaptchasitekey,
      errorinrecaptcha: false,
    };
  },
  watch: {
    currentLanguage() {
      // this.resetRecaptcha();
      this.$v.value.$model = '';
      this.containsError(this.$v.value);
      const recaptchaScript = document.getElementById('recaptchascriptid');
      recaptchaScript.async = true;
      // document.head.remove(recaptchaScript);
      // this.recaptchaScript.async = true;
      const lang = this.$store.state.currentLanguage;
      recaptchaScript.setAttribute('src', `https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=${lang}`);
      // document.head.appendChild(recaptchaScript);
    },
  },
  methods: {
    onSubmit() {
      this.$refs.invisibleRecaptcha.execute();
    },
    onVerify(response) {
      if (response) {
        this.$v.value.$model = response;
        this.containsError(this.$v.value);
      }
    },
    onExpired() {
      this.$v.value.$model = '';
      this.containsError(this.$v.value);
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
    },
  },
};
</script>
